export const virtualCurrencyLabel = 'Smart Coins';
